import { useMemo } from 'react'
import { CircularProgress, IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { makeStyles } from '@material-ui/core/styles'
import MyTable from '../MyTable/MyTable'
import SortItems from '../MyTable/SortItems'
import { arrayOf, shape, func, string, bool, number } from 'prop-types'

const styles = makeStyles((theme) => ({
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
  tableUnset: {
    whiteSpace: 'unset',
  },
  spinner: {
    color: theme.palette.primary.main,
  },
  leftDiv: {
    fontSize: 16,
    padding: '1px',
    margin: '1px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  iconDelete: {
    fontSize: 24,
    padding: '1px',
    margin: '1px',
    textAlign: 'right',
    width: '100%',
  },
  iconStyle: {
    width: '36px',
    height: '36px',
  },
}))

const DoNotCallItems = (props) => {
  const classes = styles(props)
  const {
    callbackFromParentData,
    dataFromParent,
    fetchingState,
    pageFromParent,
    pageSizeFromParent,
  } = props

  var tempData = []

  const columns = useMemo(
    () => [
      {
        Header: ' ',
        columns: [
          {
            Header: 'Do Not Call Entry',
            accessor: 'address',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
            Cell: (row) => (
              <table>
                <tbody>
                  <tr>
                    <td className={classes.leftDiv}>{row.cell.value}</td>
                    <td className={classes.iconDelete}>
                      {
                        <IconButton
                          onClick={() => {
                            callbackFromParentData(row.cell.value)
                          }}
                          aria-label="Delete"
                          className={classes.iconStyle}
                        >
                          <DeleteIcon className={classes.iconDelete} />
                        </IconButton>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            ),
          },
        ],
      },
    ],
    [], // eslint-disable-line react-hooks/exhaustive-deps
  )

  // pass only array data
  if (dataFromParent !== null) {
    tempData = dataFromParent
  }

  if (fetchingState) {
    return (
      <div className={classes.centerDiv}>
        <CircularProgress className={classes.spinner} thickness={7} />
        <h3>loading...</h3>
      </div>
    )
  } else {
    return (
      <>
        <MyTable
          columns={columns}
          data={tempData}
          defaultPageSize={pageSizeFromParent}
          defaultPageIndex={pageFromParent}
          maxPageCount={Math.ceil(tempData.length / 10)}
          defaultSortColumn={[
            {
              id: 'address',
              desc: false,
            },
          ]}
        />
      </>
    )
  }
}

export default DoNotCallItems

DoNotCallItems.propTypes = {
  callbackFromParentData: func.isRequired,
  dataFromParent: arrayOf(
    shape({
      address: string,
    }),
  ),
  fetchingState: bool,
  pageFromParent: number,
  pageSizeFromParent: number,
}
